import $ from 'jquery'
import _ from 'lodash'

export default () => {
  onDomLoad(function () {
    $(document)
      .find("[data-behavior='sync-reference-picker']")
      .select2({
        width: '100%',
        placeholder: I18n.t("components.sync.reference_picker.search_placeholder"),
      })

    const $ajaxPicker = $(document).find("[data-behavior='sync-reference-picker-ajax']")

    if ($ajaxPicker.length == 0) {
      return
    }

    const referencesUrl = $ajaxPicker.data("searchPath")
    const referenceSelector = $('#company_sync_reference_picker')
    const referenceInput = $('#company_administration_sync_reference')

    referenceSelector.on('change', () => {
      referenceInput.val(referenceSelector.find(':selected').val())
    })

    $(document)
      .find(
        "[data-behavior='sync-reference-picker-ajax']"
      )
      .select2({
        width: '100%',
        ajax: {
          url: referencesUrl,
          dataType: 'json',
          delay: 250,
          data: (params) => ({
            query: params.term,
            page: params.page || 1,
          }),
          processResults: (data, params) => {
            params.page = params.page || 1

            return {
              results: data.results,
              pagination: {
                more: data.pagination.more,
              },
            }
          },
          cache: true,
        },
        placeholder: I18n.t("components.sync.reference_picker.search_placeholder"),
        minimumInputLength: 2,
        templateResult: (reference) => reference.name,
        templateSelection: (reference) => reference.name || reference.text,
      })

    referenceInput.val(referenceSelector.find(':selected').val())
  })
}
